<template>
  <div class="pcHeadBox" ref="headBox" :class="!_isMobile && topIndex < 1 ? 'backgroundNone' : 'backgroundWhiteHead'">
    <div :class="!_isMobile ? 'head_pc' : 'head_wrap'">
      <img @click="changeActive(0,'index')" :class="!_isMobile ? 'logoImg_pc' : 'logoImg_wrap'"
        src="../assets/image/logo.png">
      <!-- pc端 -->
      <div class="menuList" v-if="!_isMobile">
        <div class="menuItem" :class="currentMenuIndex === index ? 'actived': ''" v-for="(item,index) in menuList"
          :key="index" @click="changeActive(index,item.href)" @mouseover="addActive($event, index)"
          @mouseout="removeActive($event, index)">{{item.text}}</div>
      </div>
      <!-- 移动端 -->
      <div v-if="_isMobile" class="head_Right">
        <!-- <div class="headTxt_wrap" @click="popUpShow = true">服务定制 ></div> -->
        <img v-if="!isMenuShow" class="menuIcon_wrap" @click="menuListFn"
          src="https://cdn.youjiajk.com/%E8%8F%9C%E5%8D%95%402x.png" />
        <img v-else class="closeIcon_wrap" @click="closeMenuList"
          src="https://cdn.youjiajk.com/%E5%85%B3%E9%97%AD%402x.png" />
      </div>
      <div class="menuList_wrap" v-if="isMenuShow" :class="showDocsPlat ? 'sub_menu_height' : '' ">
        <div class="item_wrap" v-for="(item,index) in menuList" :key="index" @click="changeActive(index,item.href)">
          <!-- {{item.text}} -->
          <div class="item_wrap_row">
            <span>{{item.text}}</span>
            <img v-if="item.href == 'merchant' && showArrow" src="https://cdn.youjiajk.com/guanwang_down_arrow.png" alt="">
            <img v-if="item.href == 'merchant' && !showArrow" src="https://cdn.youjiajk.com/guanwang_up_arrow.png" alt="">
          </div>
          <div class="mobile-sub" v-if="showDocsPlat && item.href === 'merchant'">
            <div class="sub_item_wrap" v-for="(item1,index1) in item.subMenuList" :key="index1" @click="changeActive(index1,item1.href)">
              {{item1.text}}
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 开放平台下拉菜单-pc -->
    <div class="down-menu-list" v-if="showDocsPlat && !_isMobile">
      <div class="down-menu">
        <div 
          class="sub_menu_item"
          v-for="(item,index) in subMenuList"
          :key="index"
          @click="changeActive(index,item.href)"
        >&nbsp;&nbsp;&nbsp;{{ item.text }}</div>
      </div>
    </div>
    <!-- 移动端 定制弹框 -->
    <div class="custom-box" v-if="popUpShow">
      <div class="dialog-box">
        <div>
          <div class="dialog-close-box">
            <span @click="popUpShow = false"></span>
          </div>
          <div class="dialog-box_title">
            我要<span>专属定制服务</span>
          </div>
          <div class="dialog-box-form">
            <div class="input-box">
              <input class="partner inputItem" v-model="partner" type="text" placeholder="姓名/公司名称">
              <input class="contactDetails inputItem" v-model="contactDetails" type="text" placeholder="手机/微信">
              <textarea class="message inputItem" v-model="message" rows="5" placeholder="合作意向"></textarea>
            </div>
            <button class="dialog-btn" @click="customizationFn">立即定制</button>
            <button v-if="isShow" class="dialog-btn" @click="goPage1">立即入驻</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        subMenuList: [
          {
            text: '供应商开放平台',
            href: 'drugsupplier'
          },
          {
            text: '健康服务开放平台',
            href: 'healthSaas'
          },
        ],
        menuList: [{
            text: '首页',
            href: 'index'
          },
          {
            text: '产品矩阵',
            href: 'product'
          },
          {
            text: '解决方案',
            href: 'insurancePlan'
          },
          {
            text: '新闻动态',
            href: 'news'
          },
          // {
          //   text: '体验优加',
          //   href: 'YJExperience'
          // },
          // {
          //   text: '互联网平台合作',
          //   href: 'internet'
          // },
          // {
          //   text: '医疗供给端',
          //   href: 'medical'
          // },
          // {
          //   text: '药品信息',
          //   href: 'drug'
          // },
          {
            text: '关于我们',
            href: 'about'
          },
          // {
          //   text: '供应商开放平台',
          //   href: 'merchant'
          // },
          {
            text: '加入优加',
            href: 'contactus'
          },
          {
            text: '开放平台',
            href: 'merchant',
            subMenuList: [
              {
                text: '供应商开放平台',
                href: 'drugsupplier'
              },
              {
                text: '健康服务开放平台',
                href: 'healthSaas'
              },
            ],
          }
        ],
        showDocsPlat: false,
        showArrow: true,
        currentMenuIndex: 0,
        _isMobile: false,
        isMenuShow: false,
        router: '',
        popUpShow: false,
        partner: '',
        contactDetails: '',
        message: '',
        navName: '',
        isShow: false,
        topIndex: 0
      }
    },
    created() {
      this._isMobile = this.$util._isMobile()
      this.navName = sessionStorage.getItem('navName')
      this.router = this.$router.history.current.path.slice(1)
      this.menuList.forEach((element, index) => {
        if (element.href === this.router) {
          this.currentMenuIndex = index
          return
        }
      });
      if (this.navName == 'medical') this.isShow = true
      window.addEventListener('scroll', this.scrolling)
    },

    watch: {
      $route(to, from) {
        this.navName = to.name
        this.menuList.forEach((element, index) => {
          if (element.href === this.navName) {
            this.currentMenuIndex = index
            return
          }
        });
      }
    },

    methods: {
      //点击添加样式
      changeActive(index, href) {
        sessionStorage.setItem('navName', href)
        if (href !== 'merchant') {
          this.showDocsPlat = false;
        }
        if (this._isMobile) {
          this.isMenuShow = false
          this.showArrow = !this.showArrow
        } else {
          this.currentMenuIndex = index
        }
        if (href == 'healthSaas') {
          let href = 'https://www.youjiajk.com/docs-plat'
          window.open(href, '_blank')
          return 
        } else if (href == 'drugsupplier') {
          return this.goPage1()
        }
        if (href == 'medical') {
          this.isShow = true
        } else {
          this.isShow = false
        }
        // 开放平台
        if(href == 'merchant') {
          this.showDocsPlat = !this.showDocsPlat;
          if (this._isMobile) {
            this.isMenuShow = true
          }
          // this.goPage1()
          return
        }

        this.goPage(href)
      },

      //移入添加样式
      addActive($event, index) {
        $event.currentTarget.className = 'menuItem actived'
      },

      //移出移除样式
      removeActive($event, index) {
        if (this.currentMenuIndex === index) {
          $event.currentTarget.className = 'menuItem actived'
        } else {
          $event.currentTarget.className = 'menuItem'
        }

      },

      //显示隐藏菜单
      menuListFn() {
        this.isMenuShow = true
      },

      closeMenuList() {
        this.isMenuShow = false
      },

      //跳转
      goPage(name) {
        this.$router.push({
          name: name
        })
      },
      //信息提交
      customizationFn() {
        if (!this.partner || this.contactDetails || this.message) {
          alert('请填写信息')
          return
        }
        axios.post('https://ums.youjiajk.com/homeControl/put/message', {
          partner: this.partner,
          contactDetails: this.contactDetails,
          message: this.message
        }).then(res => {
          // console.log(res)
          if (res.data.code === 0) {
            alert('提交成功');
            this.partner = ''
            this.contactDetails = ''
            this.message = ''
          } else {
            alert('提交失败')
          }
        }).catch(err => {
          console.log(err)
        })
      },
      //同步更新导航状态
      checkNavStyle(name) {
        this.menuList.forEach((element, index) => {
          if (element.href === name) {
            this.currentMenuIndex = index
            return
          }
        });
      },
      goPage1() {
        // let href = 'https://drugsupplier.youjiajk.com/#/'
        let href = 'https://drugsupplier.youjiajk.com/docs-plat/'
        window.open(href, '_blank')
      },
      scrolling() {
        this.topIndex = document.body.scrollTop || document.documentElement.scrollTop //获取滚动条位置 
      }
    }
  }
</script>

<style scoped="" lang="less">
  .pcHeadBox {
    background: #FFFFFF;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
  }

  .backgroundNone{
    background: none;
  }

  .down-menu-list {
    display: flex;
    justify-content: flex-end;
    padding-right: 110px;
  }
  .down-menu {
    background: #fff;
    width: 156px;
    height: 102px;
    box-shadow: 0px 6px 10px 0px rgba(0,0,0,0.06); 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 12px 0 12px 0px;
    .sub_menu_item {
      width: 100%;
      font-size: 16px;
      font-family: SourceHanSansCN, SourceHanSansCN-Normal;
      font-weight: normal;
      text-align: left;
      color: #333333;
      padding: 12px 0;
      cursor: pointer;
    }
    .sub_menu_item:active, .sub_menu_item:hover, .sub_menu_item:visited  {
      width: 156px;
      color: #FD8246;
      font-weight: 700;
      background: #F2F3F5;
    }
  }
  .mobile-sub {
    width: 100%;
    margin-top: 0.36rem;
    background: #212129;
    padding: 0.36rem 0.72rem;
    margin-left: -0.72rem;
    .sub_item_wrap + .sub_item_wrap {
      padding: 15px 0;
    }
  }
  .head_pc {
    width: 1200px;
    height: 88px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    margin: 0 auto;

    .logoImg_pc {
      width: 114px;
      height: 43px;
      z-index: 99;
    }

    .menuList {
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99;

      .menuItem {
        font-family: Source Han Sans CN, Source Han Sans CN-5;
        font-size: 16px;
        color: #333333;
        font-weight: 400;
        margin-left: 50px;
        cursor: pointer;
      }

      .actived {
        color: #FD8246;
        font-weight: 700;
        position: relative;

        &::after {
          content: '';
          width: 8px;
          height: 3px;
          background: #FD8246;
          position: absolute;
          bottom: -14px;
          left: 50%;
          z-index: 99px;
          border-radius: 10px;
          margin-left: -4px;
        }
      }
    }
  }

  .head_wrap {
    height: 100%;
    height: 1.54rem;
    background-color: #ffffff;
    z-index: 2;
    padding: 0.49rem 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    .logoImg_wrap {
      width: 1.3rem;
      padding-left: 0.4rem;
    }

    .head_Right {
      display: flex;
      justify-content: right;
      align-items: center;
      font-size: 0.24rem;
      padding-right: 0.4rem;

      .headTxt_wrap {
        color: #FD8246;
        margin-right: 0.65rem;
        font-weight: 550;
      }

      .menuIcon_wrap {
        width: 0.48rem;
        height: 0.36rem;
      }

      .closeIcon_wrap {
        width: 0.42rem;
        height: 0.42rem;
      }

    }

    .menuList_wrap {
      position: fixed;
      top: 1.54rem;
      left: 0;
      right: 0;
      bottom: 0;
      box-sizing: border-box;
      width: 100%;
      background: #031323;
      font-size: 0.28rem;
      overflow: scroll;
      z-index: 10;
      overflow: hidden;
      height: 9.2rem;

      .item_wrap {
        color: #ffffff;
        font-size: 0.28rem;
        font-weight: 400;
        font-family: Source Han Sans CN, Source Han Sans CN-5;
        width: 100%;
        display: inline-block;
        padding: 0.36rem 0.72rem;
        border-bottom: 0.02rem solid rgba(255, 255, 255, .1);
        line-height: 0.42rem;

        &:last-child {
          border-bottom: none;
        }

        .item_wrap_row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 80%;
          img {
            width: 23px;
            height: 23px;
          }
        }
      }
    }
    .sub_menu_height {
      height: 11rem;
    }
  }

  .custom-box {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .6);
    position: fixed;
    top: 0;
    z-index: 20;

    .dialog-box {
      width: 6.4rem;
      border-radius: 00.2rem;
      background: #FFFFFF;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      >div {
        margin: 0.42rem;

        .dialog-close-box {
          display: flex;
          justify-content: flex-end;

          span {
            width: 0.28rem;
            height: 0.27rem;
            background-size: auto 0.24rem;
            background-image: url("https://cdn.youjiajk.com/%E5%85%B3%E9%97%AD%402x.png");
            background-repeat: no-repeat;
          }
        }

        .dialog-box_title {
          font-size: 0.4rem;
          color: #333333;
          line-height: 0.56rem;
          padding-bottom: 0.4rem;
          text-align: center;

          span {
            color: #FD8246;
          }
        }

        .dialog-box-form {
          padding-bottom: 0.4rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .input-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;

            .inputItem {
              width: 90%;
              border: none;
              background: #F5F5F5;
              padding: 0.25rem 0.12rem;
              outline: none;
              margin-bottom: 0.2rem;
            }
          }

          .dialog-btn {
            width: 95%;
            padding: 0.25rem 0.12rem;
            background: #FD8244;
            color: #FFFFFF;
            font-size: 0.2rem;
            font-weight: 600;
            outline: none;
            border: none;
            border-radius: 0.04rem;
            margin-top: 0.1rem;
          }
        }
      }


    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Head.vue